import React from 'react';

/**
 * LightModeWrapper - Forza la modalità chiara per i componenti figli
 *
 * Questo componente previene l'applicazione degli stili dark mode
 * ai suoi componenti figli, garantendo che rimangano sempre in modalità chiara
 * indipendentemente dalle impostazioni di sistema o preferenze utente.
 *
 * @example
 * <LightModeWrapper>
 *   <MyComponent />
 * </LightModeWrapper>
 */

interface LightModeWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function LightModeWrapper({ children, className = '' }: LightModeWrapperProps) {
  return (
    <div className={`force-light-mode ${className}`}>
      {children}
    </div>
  );
}
